"use client";
import { Link } from "@/i18n/routing";
import { IconEmptyCart } from "@repo/assets/images";
import { Button } from "@repo/ui";
import { useTranslations } from "next-intl";

const EmptyCart = ({ closeMinicart }) => {
  const t = useTranslations("Cart");
  return (
    <div className="py-14 text-center">
      <IconEmptyCart className="text-icon-color fill-icon-bg mx-auto" />
      <p className="text-supportiveBlack py-3 text-xl">{t("Empty_Cart")}</p>
      <p className="text-supportiveGray4">{t("Empty_Cart_Message")}</p>
      <p className="text-supportiveGray4 pb-6">{t("Start_Exploring")}</p>
      <Link href="/" onClick={() => closeMinicart?.()}>
        <Button variant="primary" size="md">
          {t("Shop_Now")}
        </Button>
      </Link>
    </div>
  );
};

export default EmptyCart;
